import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from './Footer';
import MiniPlayer from './MiniPlayer';
import { useApp } from '../context/AppContext';
import { usePlayer } from '../context/PlayerContext';

export default function AppLayout() {
  const { announcement } = useApp();
  const { current } = usePlayer();
  const loc = useLocation();
  const fullScreen = loc.pathname === '/feed';
  const hasPlayer = !!current && !fullScreen;
  return (
    <div className="min-h-screen bg-[var(--theme-bg)] text-[var(--theme-fg)]">
      <Navbar />
      <div className="flex pt-14">
        <Sidebar />
        <main className="flex-1 min-w-0 lg:ml-60 flex flex-col">
          {announcement && !fullScreen && (
            <div className="px-4 md:px-8 pt-4">
              <div className="card-shell px-4 py-3 text-[13.5px] text-white/90 border-[#ff2e63]/40" style={{ background: 'linear-gradient(90deg, rgba(255,46,99,0.12), rgba(255,46,99,0.02))' }}>
                📣 {announcement}
              </div>
            </div>
          )}
          <div className={fullScreen ? 'flex-1' : 'px-4 md:px-8 py-6 flex-1'} style={hasPlayer ? { paddingBottom: '88px' } : undefined}>
            <Outlet />
          </div>
          {!fullScreen && <Footer />}
        </main>
      </div>
      <MiniPlayer />
    </div>
  );
}
